import { FC, useContext, useEffect } from "react";
import Modal from "react-modal";
import { UserContext } from "../../../Provider";
import AGButton from "../../../components/Button";
import CardToggle from "../../../components/CardToggle";
import { RolesHandle } from "../../../components/RolesHandle";
import Tooltip from "../../../components/Tooltip";
import { Div } from "../commerce.styled";
import { ICardItem } from "./cardItem.props";
import { CardContainer, TagOptionService } from "./cardItem.styled";
import { ADMIN_ORGANIZATION } from "../../../utils/constant";

const SecondmentItems: FC<ICardItem> = ({
  header,
  setShow,
  children,
  childrenSeeking,
  firmId,
  tagService,
  className,
  childrenClassName,
  titleTooltip,
  isShowToggleButton = false,
  isShowCollapse,
  buttonText,
  buttonTextClassName,
  isReload,
  countData = 0,
  countSeekingData = 0,
  createdSecondment = 0
}) => {
  const user = useContext(UserContext);

  // const [secondmentsData, setSecondmentsData] = useState<CommerceFirmData[]>();
  // const { mutate: getProducts } = useMutation(
  //   (data: any) =>
  //     httpGET({
  //       url: `/FirmProfile/secondments/${firmId}`,
  //     }),
  //   {
  //     onSuccess: (rs) => {
  //       setSecondmentsData(rs.firmDatas as CommerceFirmData[]);
  //     },
  //   },
  // );

  useEffect(() => {
    if (firmId && !isReload) {
      Modal.setAppElement("#root");
      // getProducts(firmId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firmId, isReload]);

  if (!firmId) {
    return null;
  }

  return (
    <CardContainer>
      <CardToggle
        isShowToggleButton={isShowToggleButton}
        isCollapse={isShowCollapse}
        title={
          <Div className={`card-title ${className} justify-between !pb-0`}>
            {countData === 0 && countSeekingData === 0 ? (
              <div className="flex items-center justify-start h-[30px]">
                <p className="text-[#637381] text-[14px]">No secondments found.</p>
              </div>
            ) : null}
            <div className="flex items-center space-x-[5px]">
              <h2>
                {header} {tagService ? <TagOptionService>{tagService}</TagOptionService> : null}
              </h2>
              {titleTooltip && <Tooltip text={titleTooltip} />}
            </div>

            {
              <RolesHandle
                firmId={firmId}
                fkOrgId={firmId}
                roles={[
                  "Admin",
                  "FirmCommerceManagement",
                  "ManagingPartner"
                ]}>
                <AGButton
                  className={`flex items-center space-x-2 group w-28 ${buttonTextClassName} bg-white customDesktop:hover:bg-[#0971A2] transition-colors duration-300`}
                  type="Primary"
                  clasNameCus="customButton"
                  onClick={(e) => {
                    setShow();
                  }}
                >
                  <PlusIcon className="fill-[#0971A2] customDesktop:group-hover:fill-white" />
                  <span className="text-[#0971A2] customDesktop:group-hover:text-white">{buttonText}</span>
                </AGButton>
              </RolesHandle>
            }
          </Div>
        }
      >
        <Div className={`card mt-[15px]`}>
          {
            countData > 0 && <>
              <TitleSecondment title="Offering" />
              <Div className={`card-add ${childrenClassName}`}>{children}</Div>
            </>
          }



          {countSeekingData > 0 && <>
            <TitleSecondment title="Seeking" />
            <Div className={`card-add ${childrenClassName}`}>{childrenSeeking}</Div>
          </>
          }
        </Div>
      </CardToggle>
    </CardContainer>
  );
};

export default SecondmentItems;

const TitleSecondment = ({ title }: { title: string }) => {
  return <div className="my-[20px] first:mt-0">
    <p className="text-[#333333] text-[1.1875rem] font-bold ">{title}</p>
  </div>

}

export const PlusIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z" />
    </svg>
  );
};
